import { useQuery } from "react-query";

import { dropdownValuesService } from "services";

type UseFdOmahaProcessorTypesQueryProps = {
	options?: any;
};

const useFdOmahaProcessorTypesQuery = ({ options }: UseFdOmahaProcessorTypesQueryProps = {}) =>
	useQuery("FDOmahaProcessorTypes", dropdownValuesService.getFdOmahaProcessorTypes, {
		...options,
	});

export default useFdOmahaProcessorTypesQuery;